import { TextsListView } from '@today/ui-domain'
import { useTextList } from '@/hooks/content/useTextList'

/** `/content/texts` — the texts list (TO-420 content-admin-ui REQ-002). */
export function TextsListPage() {
	return <TextsListView {...useTextList()} />
}
